import {
    useState, useMemo,
} from 'react'

import useLabel from 'app/hooks/useLabel'

import FilterPopover from '../FilterPopover'
import Switch from '../Switch'
import {
    BooleanSwitchFilterOptions,
} from '../../types/common.types'
import useStyles from './SwitchFilter.styles'

const SwitchFilter = ({
    filter, setFilter, filterOptions,
}: Readonly<{
    filter?: boolean,
    setFilter: (filter: boolean) => void,
    filterOptions: BooleanSwitchFilterOptions
}>) => {
    const {
        classes,
    } = useStyles()
    const [
        state,
        setState,
    ] = useState<boolean>(filter)

    const [
        hasChanges,
        setHasChanges,
    ] = useState<boolean>(false)

    const l = useLabel()

    const commitChanges = (): void => {
        if (hasChanges) {
            setFilter(state)
        }
    }

    const localOnChange = (newValue: boolean): void => {
        setState(newValue)
        setHasChanges(true)
    }

    const active = useMemo((): boolean => {
        return filter !== undefined
    }, [filter])

    return (
        <FilterPopover
            active={active}
            onClose={commitChanges}

        >
            <Switch
                title={l(filterOptions.title)}
                onChange={localOnChange}
                value={state}
                className={classes.formControl}
            />
        </FilterPopover>
    )
}

export default SwitchFilter
